<template>
  <div class="container">
    <!-- 顶部 -->
    <div class="topContent">
        <div class="dh_wz">
          <div class="dh_wz_qq"> </div>
          <div class="dh_wz_tb"></div>
          <div class="dh_wz_wz">高标准农田</div>
        </div>
        <div class="dh_lb">
          <router-link :to="{path:'/plant'}"><div class="dh_lb_bt dh_lb_bt_cur">种植大棚</div></router-link>
           <router-link :to="{path:'/gbzntjs'}"><div class="dh_lb_bt">建设预览</div></router-link>
          <router-link :to="{path:'/gbzntyj'}"><div class="dh_lb_bt">运营状态</div></router-link>
          <!-- <router-link :to="{path:'/zuowufenxi'}"><div class="dh_lb_bt">农作物分析</div></router-link> -->
          <router-link :to="{path:'/zhinengGG'}"><div class="dh_lb_bt">智能灌溉</div></router-link>
          <router-link :to="{path:'/binghai'}"><div class="dh_lb_bt">病虫害管理</div></router-link>
          <router-link :to="{path:'/plantmoxing'}"><div class="dh_lb_bt">种植模型</div></router-link>
          <router-link :to="{path:'/suyuan'}"><div class="dh_lb_bt">农业溯源</div></router-link>
        </div>
        <div class="titleRightImg">
          <router-link :to="{ path: '/' }"><img src="../assets/img/gbzntyj/sy.png" class="return"/></router-link>
          <img src="../assets/img/gbzntyj/fh.png" class="return"  @click="clickReturn"/>
        </div>
      </div>
    <!-- 内容 -->
    <div class="content">
      <div class="left">
        <!-- 农田介绍 -->
        <Box1 title="项目介绍" :isImg="true" pathName="gbzntjs">
            <div class="leftContent1" >
            <div class="contentLine contentLine1"></div>
            <div class="contentLine contentLine2"></div>
            <div class="contentLine contentLine3"></div>
            <div class="contentLine contentLine4"></div>
            <div class="leftContent1Left"><img src="../assets/img/plant/img.png" /></div>
            <div class="leftContent1Right">
              <div class="leftContent1RightTit">上蔡高标农田</div>
              <!-- <marquee behavior="scroll" direction="up"  width="100%" height="200px" class="textScroll">{{text}}</marquee> -->
              <div class="textScroll">
                 <txtScroll>
                  <div v-for="item in textList" :key="item.id" class="scroll_item">
                    {{item.title}}
                  </div>  
                </txtScroll>
              </div>
             
            </div>
          </div>  
        </Box1>
        <!-- 种植产品 -->
        <Box1 title="种植产品" :isImg="true" pathName="plantmoxing">
            <div class="contentLine contentLine1"></div>
            <div class="contentLine contentLine2"></div>
            <div class="contentLine contentLine3"></div>
            <div class="contentLine contentLine4"></div>
            <div class="leftContent2">
              <div class="leftContent2Left">
                <div class="leftContent2LeftTit">种植作物</div>
                <div class="leftContent2LeftCon">
                  <img src="../assets/img/plant/left2Left1.png" class="leftContent2LeftConBg" />
                  <div class="icon"><img src="../assets/img/plant/nzw.png"/></div>
                </div>
              </div>
              <div class="leftContent2Right">
                <div class="leftContent2RightItem" v-for="(item,index) in left2Right" :key="index">
                  <div class="leftContent2RightItemLeft"><span>{{item.name}}</span><span>占地{{item.area}}亩</span></div>
                  <div class="icon"><img :src="item.icon" /></div>
                </div>
              </div>
            </div>
        </Box1>
        <!-- 种植类型 -->
        <Box2 title="农产品安全" :isImg="true" pathName="suyuan">
            <div class="leftContent3">
              <div class="leftContent3Item" v-for="(item,index) in left3Data" :key="index">
                <div class="leftContent3Name">
                  <div class="circle">{{item.value}}</div>
                  <div class="circle1"></div>
                  <div class="circle2"></div>
                  <div class="circle3"></div>
                </div>
                <div class="leftContent3Value">{{item.name}}</div>
              </div>
            </div>
        </Box2>
      </div>
      <div class="center"></div>
      <div class="right">
        <!-- 智能设备 -->
        <Box1 title="智能设备" pathName="plant">
            <!-- <RightSwiper /> -->
            <div class="rightBox1">
              <div class="rightItem1" v-for="(item,index) in rightData" :key="index">
                <div class="iconBox">
                  <div class="iconBoxBg"><img :src="item.icon" class="icon" /></div>
                </div>
                <div class="rightItem1Right">
                  <div class="rightItem1Right1">
                    <div class="rightItem1Right1Left">{{item.name}}</div>
                    <div class="rightItem1Right1Right"><span>{{item.isLine+item.noLine}}</span>盏</div>
                  </div>
                  <div class="rightItem1Right2">
                    <div class="rightItem1Right2Item">
                      <div class="status">在线</div>
                      <div class="num"><span>{{item.isLine+item.noLine}}</span>盏</div>
                    </div>
                    <div class="rightItem1Right2Item">
                      <div class="status">开启</div>
                      <div class="num"><span>{{item.isLine}}</span>盏</div>
                    </div>
                    <div class="rightItem1Right2Item">
                      <div class="status">离线</div>
                      <div class="num"><span>{{item.noLine}}</span>盏</div>
                    </div>
                  </div>
                </div>
                <img src="../assets/img/plant/jt.png" class="rightJiantou" />
              </div>
              <div class="line"></div>
            </div>
        </Box1>
        <Box1 title="设备监控"  pathName="plant">
          <div class="rightBox2">
            <div class="rightBox2Left">
              <img src="../assets/img/plant/right2Line.png" class="leftLine" />
              <div class="centerList">
                <div class="centerListItem" v-for="(item,index) in rightData2" :key="index">{{item.name}}</div>
              </div>
              <img src="../assets/img/plant/right2Line.png" class="rightLine"/>
            </div>
            <div class="rightBox2Right">
              <div class="videoBox" id="video"><vue3VideoPlay :control="false"  :controlBtns="false" color="#ff0000" width="100%" height="100%" title="冰河世纪" :src="options.src" :type="options.type" :autoPlay="false"  @play="onPlay" /></div>
            </div>
          </div>
        </Box1>
        <Box2 title="雨量趋势"  pathName="qihouYj">
          <RightLine/>
        </Box2>
      </div>
    </div>
  </div>
  <footer1 />
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance
} from "vue";


// import Left1Line from "../components/cangchu/left1Line";

import Box1 from '../components/plant/Box1.vue'
import Box2 from '../components/plant/Box2.vue'
import RightLine from '../components/plant/RightLine.vue'
import RightSwiper from '../components/plant/RightSwiper.vue'
import txtScroll from "../components/xiaofeiChanpin/txtScroll.vue"
import footer1 from "../components/footer.vue";
import { useRouter } from 'vue-router'


import { setInterval, clearInterval } from "timers";
export default {
  name: "Home",
  setup() {
    const { proxy } = getCurrentInstance();
    // const timer = ref(null);
    const router = useRouter();
    const state = reactive({
      currentTime: "",
      navList:[
        {name:"农场概述",path:"",animateShow:false},
        {name:"环境监控",path:"",animateShow:false},
        {name:"设备运维",path:"",animateShow:false},
        {name:"灌溉系统",path:"",animateShow:false}
      ],
      textList:[
        {title:'上蔡县5万亩高标准农田示范区建设项目涉及无量寺乡、黄埠镇2个乡镇的10个行政村，其中，其中无量寺乡涉'},
        {title:'及王连湖村、后陈村、吴宋村、陈寨庙村、郝庄村；黄埠镇涉及冯坡村、狮子口村、周庄村、后张村和常庄村等10个行政村。'},
        {title:'上蔡县5万亩高标准农田示范区建设项目涉及无量寺乡、黄埠镇2个乡镇的10个行政村，其中，其中无量寺乡涉'},
        {title:'及王连湖村、后陈村、吴宋村、陈寨庙村、郝庄村；黄埠镇涉及冯坡村、狮子口村、周庄村、后张村和常庄村等10个行政村。'},
        {title:'上蔡县5万亩高标准农田示范区建设项目涉及无量寺乡、黄埠镇2个乡镇的10个行政村，其中，其中无量寺乡涉'},
        {title:'及王连湖村、后陈村、吴宋村、陈寨庙村、郝庄村；黄埠镇涉及冯坡村、狮子口村、周庄村、后张村和常庄村等10个行政村。'},
        ] ,
      left2Right:[
        {name:"花生",area:165,icon:require('../assets/img/plant/hs.png')},
        {name:"玉米",area:156,icon:require('../assets/img/plant/dd.png')},
        {name:"大豆",area:258,icon:require('../assets/img/plant/ym.png')},
      ],
      left3Data:[
        {name:"农作物（吨）",value:14},
        {name:"农事记录（条）",value:18},
        {name:"农资记录",value:14},
        {name:"地块数量",value:18},
        {name:"销售城市数量",value:16},
        {name:"农作物种类",value:14}
      ],
      rightData:[
        {name:"照明设备",isLine:380,noLine:80,icon:require('@/assets/img/plant/zm.png')},
        {name:"监控设备",isLine:380,noLine:80,icon:require('@/assets/img/plant/sxt.png')},
        {name:"消防设备",isLine:380,noLine:80,icon:require('@/assets/img/plant/xf.png')},
      ],
      rightData2:[{name:"一号大棚-VR12"},{name:"二号大棚-VR12"},{name:"三号大棚-VR12"},{name:"四号大棚-VR12"},{name:"二号大棚-VR12"},{name:"三号大棚-VR12"},{name:"四号大棚-VR12"}],
      options:{
        src: require("@/assets/video/plant.mp4"), //视频源
        type: 'video/mp4', //视频类型
      }
    });
    onMounted(() => {
      // clearInterval(state.timer.value);
      // state.value = setInterval(() => {
      //   state.currentTime = proxy.$utils.getCurrentTime();
      // }, 1000);
       
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
      
    })
    const onPlay = (ev) => {
      console.log('播放')
    }
    // 返回上一页
    function clickReturn(){
      router.go(-1);
    }
// 鼠标经过
    function mouseenter(index){
      // let rightData1 = 
      state.navList[index].animateShow = true
    }
    // 鼠标离开
    function mouseleave(index){
      // let rightData1 = 
      state.navList[index].animateShow = false
    }




    return {
      ...toRefs(state),
      // timer,
      mouseenter,
      mouseleave,
      // classRight,
      RightSwiper,
      clickReturn
    };
  },
  components: {
     Box1,
     Box2,
     RightLine,
     RightSwiper,
     txtScroll,
     footer1
  },
};
</script>
<style lang="less" scoped>
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state{
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon{
  font-size: 20px!important;
}
.scrolling-text-container {
  height: 100px; /* 设置容器的高度 */
  overflow: hidden;
}

.scrolling-text-content {
  display: block;
  height: 200%; /* 假设此处为两倍于容器高度 */
  line-height: 1.5; /* 根据实际情况设置行高 */
  white-space: nowrap;
  transform: translateY(0);
}
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("../assets/font/DS-DIGIT.TTF");
}
.container{
  width: 100%;
  height: 100vh;
  background: url("../assets/img/plant/bg1.jpg") no-repeat top center;
  background-size: 100% 100%;
  color: #fff;
  position: relative;
  overflow: hidden;
  // 头部
 .title{
    position: relative;
    width: 100%;
    height: 97px;
    background: url("../assets/img/plant/bt.png") no-repeat top center;
    background-size: 100% 100%!important;
    color: #fff;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .return{
      width: 68px;
      height: 23px;
      cursor: pointer;
      margin-right: 50px;
      // margin-top: 16px;
      position: relative;
      z-index: 999;
    }
    .return:first-child{
      margin-left: 50px;
    }
    .guang1{
      position: absolute;
      top: -36px;
      left: 0;
      animation: titleGuang1 2s linear infinite;
      z-index: 0;
    }
    .guang2{
      position: absolute;
      top: -36px;
      right: 0;
      animation: titleGuang2 2s linear infinite;
    }
    @keyframes titleGuang1{
      0%{
        left: 0;
      }
      100%{
        left: 15%;
      }
    }
    @keyframes titleGuang2{
      0%{
        right: 0;
      }
      100%{
        right: 15%;
      }
    }
       
  }

  .topContent {
    width: 100%;
    height: 90px;
    position: relative;
     .dh_wz {
    width: 170px;
    height: 47px;
    position: absolute;
    left: 3%;
    top: 20%;
    background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
    background-size: 100% 100%;

    .dh_wz_qq {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      position: absolute;
      top: 6px;
      left: 7px;
      border: 1px solid #ffc600; /* 添加一个黑色的边框 */
      animation: guangying 2s linear infinite;
    }
    .dh_wz_tb {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 15px;
        top: 14px;
        background: url("../assets/img/gbzntyj/nt.png") no-repeat top center;
        background-size: 100% 100%;
        animation: topIcon 2s linear infinite;
        
      }
    .dh_wz_wz {
      width: 120px;
      height: 47px;
      line-height: 47px;
      color: #fff;
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      position: absolute;
      right: 5%;
    }
  }
  .dh_lb {
    // width: 900px;
    height: 45px;
    position: absolute;
    left: 23%;
    top: 20%;
    display: flex;
    flex-flow: row;
    a{
      text-decoration: none;
    }

    .dh_lb_bt {
      width: 124px;
      height: 43px;
      background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #3bf4be;
      transition: all 0.5s ease-out;
    }
    .dh_lb_bt:hover,.dh_lb_bt_cur {
      width: 124px;
      height: 43px;
      cursor: pointer;
      background: url("../assets/img/gbzntyj/xz.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #fff;
    }
  }
    .titleRightImg {
      position: absolute;
      right: 0;
      top: 27%;
      .return {
        width: 77px;
        height: 32px;
        margin-right: 15px;
        cursor: pointer;
        position: relative;
        z-index: 999;
      }
    }
  }
  // 内容
  .content{
    display: flex;
    width: 100%;
    min-height: calc(100vh - 80px);
    box-sizing: border-box;
    padding: 20px 20px 0;
    .left,.right{
      width: 522px;
      display: flex;
      flex-direction: column;
    }
    .center{
      flex: 1;
    }
    .left{

        .leftContent1{
          display: flex;
          justify-content: space-between;
          .leftContent1Left{
            width: 250px;
            background: url("../assets/img/plant/imgBg.png") no-repeat top center;
            background-size: 100% 100%;
            margin: 10px 0 10px 10px;
            padding: 8px;
            box-sizing: border-box;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .leftContent1Right{
             width: 218px;
            background: url("../assets/img/plant/leftRightBg.png") no-repeat top center;
            background-size: 100% 100%;
            margin: 10px 10px 10px 0;
            overflow: hidden;
            .leftContent1RightTit{
              font-size: 16px;
              height: 46px;
              line-height: 46px;
              position: relative;
              z-index: 999;
            }
            .textScroll{
              width: 100%;
              // height: 100%;
              font-size: 14px;
              line-height:24px;
              text-align: left;
              padding: 10px;
              box-sizing: border-box;
              // animation: textScroll 4s linear infinite;
              overflow: hidden;
              // border: 1px solid #f00;
            }
          }
        }
        .leftContent2{
          display: flex;
          // height: 250px;
          background: rgba(0,119,129,.2);
          margin: 5px 10px 0;
          justify-content: center;
          .leftContent2Left{
            width: 170px;
            height: 236px;
            background: url("../assets/img/plant/left2Left.png") no-repeat top center;
            background-size: 100% 100%!important;
            margin-right: 20px;
            margin-top: 10px;
            padding: 10px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .leftContent2LeftTit{
              height: 40px;
              font-size: 16px;
              line-height: 40px;
            }
            .leftContent2LeftCon{
              flex: 1;
              position: relative;
              .leftContent2LeftConBg{
                width: 104px;
                height: 104px;
                animation: guangying 2s linear infinite;
                margin-top: 20px;
              }
              .icon{
                position: absolute;
                top:51px;
                left: 34px;
                // animation: jiantou 1s linear infinite;
              }
              // 圆环
              // border: 1px solid;
              // margin: 10px 0 30px;
            }
          }
          .leftContent2Right{
            width: 223px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .leftContent2RightItem{
              width: 223px;
              height: 76px;
              background: url("../assets/img/plant/left2Right.png") no-repeat top center;
              background-size: 100% 100%!important;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 10px;
              .leftContent2RightItemLeft{
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                span{
                  display: block;
                  line-height: 18px;
                }
                span:nth-child(1){
                  font-size: 16px;
                }
                span:nth-child(2){
                  font-size: 12px;
                }
              }
              .icon{
                width: 45px;
                height: 45px;
                margin-right: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                  margin-right: 5px;
                  animation: left2 1s linear infinite;
                }
              }
              
            }
            .leftContent2RightItem:last-child{
              margin-bottom: 10px;
            }
          }
        }
    }
    // 左三
     .leftContent3{
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          padding: 10px 0;
          .leftContent3Item{
            width: 33%;
            display: flex;
            flex-direction: column;
            // justify-content: space-between;
            align-items: center;
            margin: 10px 0;
            .leftContent3Name{
              width: 66px;
                height: 66px;
                position: relative;
              .circle{
                width: 100%;
                height: 100%;
                border:3px solid #0E4743;
                border-radius: 50%;
                text-align: center;
                line-height: 60px;
                font-size: 16px;
              }
              .circle1{
                width: 66px;
                height: 66px;
                border:2px solid #3EFFE1;
                border-radius: 50%;
                text-align: center;
                line-height: 60px;
                position: absolute;
                top: 0;
                left: 0;
              }
              .circle1{
                clip:rect(0,30px,30px,0); 
                animation: guangying 2s linear infinite;
              }
            }
            .leftContent3Value{
                margin-top: 10px;
                font-size: 14px;
              }
          }
           .leftContent3Item:nth-child(even) {
              .circle{
                border:3px solid #2B3852;
              }
              .circle1{
                border:2px solid #663AF7;
              }
            }
    }

    // 右一
    .rightBox1{
        width: 100%;
        height: 250px;
        box-sizing: border-box;
        text-align: center;
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        overflow-x: hidden;
        overflow-y: auto;
        .rightItem1{
          display: flex;
          width: 440px;
          height: 86px;
          margin: 10px 30px;
          background-size:contain!important;
          position: relative;
          // margin-right: 30px;
          .iconBox{
            width: 86px;
            height: 86px;
            background-size:cover!important;
            position: absolute;
            left:20px;
            top: 10px;
            animation: opacity 2s linear infinite;
            animation-delay: 1s;
            .iconBoxBg{
              width: 72px;
              height: 72px;
              background-size:cover!important;
              position: absolute;
              left:7px;
              top: 7px;
              .icon{
                width: 36px;
                height: 40px;
                position: absolute;
                left: 18px;
                top: 16px;
                animation: opacity 1s linear infinite;
               
              }
            }
          }
          .rightItem1Right{
            margin-left: 140px;
            margin-right: 32px;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 15px;
            
            .rightItem1Right1{
              width: 100%;
              display: flex;
              justify-content: space-between;
              line-height: 32px;
              margin-top: 8px;
              .rightItem1Right1Left{
                color: #E3FCE3;
              } 
              .rightItem1Right1Right{
                color: #93E593;
                margin-right: 10px;
                span{
                  font-size: 18px;
                  font-weight: bold;
                  margin-right: 5px;
                }
              }
            }
            .rightItem1Right2{
              width: 100%;
              display: flex;
              justify-content: center;
              margin-top: 6px;
              font-size: 13px;
              .rightItem1Right2Item{
                width: 100%;
                .num{
                  span{
                    font-size: 16px;
                    margin-right: 5px;
                  }
                }
              }
            }
          }
        }
        .rightItem1:nth-child(1){
          background: url("../assets/img/plant/rightItem1.png") no-repeat top right;
          .iconBox{
            background: url("../assets/img/plant/lwq.png") no-repeat;   
            .iconBoxBg{
              background: url("../assets/img/plant/lnq.png") no-repeat;   
            }
          }
        }
        .rightItem1:nth-child(2){
          background: url("../assets/img/plant/rightItem2.png") no-repeat top right;
          .iconBox{
            background: url("../assets/img/plant/cwq.png") no-repeat;
            .iconBoxBg{
              background: url("../assets/img/plant/cnq.png") no-repeat;   
            }  
          }
        }
        .rightItem1:nth-child(3){
          background: url("../assets/img/plant/rightItem3.png") no-repeat top right;
          .iconBox{
            background: url("../assets/img/plant/wql.png") no-repeat;
            .iconBoxBg{
              background: url("../assets/img/plant/nql.png") no-repeat;   
            }  
          }
        }
        .rightJiantou{
          width: 25px;
          height: 19px;
          position: absolute;
          top: 18px;
          right: 0;
          animation: jiantou 1s linear infinite;
        }
    }
    .rightBox1::-webkit-scrollbar,.centerList::-webkit-scrollbar{
      display: none; /* Chrome Safari */
    }
    .line{
      width: 479px;
      height: 5px;
      background: url("../assets/img/plant/x.png") no-repeat;
      position: absolute;
      bottom: 0;
      left: 0;
    }
      //  右二   
     .rightBox2{
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 256px;
      .rightBox2Left{
        width:198px ;
        height: 100%;
        position: relative;
        .leftLine{
          position: absolute;
          width: 21px;
          height: 236px;
          left: 20px;
          top: 10px;
        }
        .rightLine{
          position: absolute;
          width: 21px;
          height: 236px;
          right: 0;
          top: 10px;
          transform: rotate(180deg);
        }
        .centerList{
          height: 90%;
          margin-top: 5%;
          scrollbar-width: none; /* firefox */
          -ms-overflow-style: none; /* IE 10+ */
          overflow-x: hidden;
          overflow-y: auto;
          .centerListItem{
            width: 179px;
            height: 31px;
            line-height: 31px;
            margin: 15px auto;
            text-align: center;
            background: url("../assets/img/plant/right2ListBg.png") no-repeat;
            font-size: 14px;
            text-shadow: 0 2px rgba(0,0,0,.2);
        }
        }  
      }
      .rightBox2Right{
        width: 280px;
        height: 180px;
        background:  url("../assets/img/plant/shipinBg.png") no-repeat center center;
        background-size: 100% 100%!important;
        margin: 40px 15px 0;
        box-sizing: border-box;
        text-align: center;
        .videoBox{
          width: 94%;
          height: 92%;
          margin: 3% 2%;
        }
      }
     } 
  }
}

   .schoolRank{
    height:5rem;
    width:97%;
    margin-left:1%;
    margin-top:.1rem;
    border-radius: 15px;
    border: solid #ccc 1px;
    box-shadow: 0 0 0.266667rem rgba(131, 171, 175, 0.5);
    background-color: #fff;
  .seamless-warp{
    width: 100%;
    height: 5rem;
    overflow: hidden;
    // background-color red
    .rank{
      width: 90%;
      margin-left: 5%;
      line-height: .8rem;
      margin-top: .3rem;
      li{
        height: 1.6rem;
        font-size: 20px;
        margin-left: 10%;
        margin-bottom: 20px;
        // background-color red
        .numbers{
          font-size: 16px;
          color: black;
        .front{
          float: left;
          width: 10%;
          line-height: .8rem;
          margin-left: -10%;
          // background-color skyblue
          }
        }
      }
  }
}
} 
#video .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}

@keyframes textScroll {
    0% {
        transform: translateY(0);
    }
   100% {
        transform: translateY(-100%);
    }
}  
@keyframes flowCss {
      0% {
          /* 移动背景位置 */
          background-position: 0 0;
      }

      100% {
          background-position: -400% 0;
      }
  }

@keyframes bianda {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      transform: scale(0.3);
  } 
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  50%{
    transform: scale(1);
  }
   100%{
    transform: scale(0.3);
  }
}
@keyframes navLine {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                      
      left: 0;
  } 
  50%{                       
      left: 85%;
  }
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  100%{
    left:0
  }
}
@keyframes infoLine {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      
      left: 0;
  } 
  50%{                     
      
      left: 60%;
  }
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  100%{
    left:0
  }
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
  0% {
          transform: rotate(0deg);
      }

  100% {
      transform: rotate(-360deg);
  }
}
/* 定义关键帧 */
@keyframes opacity {    /*引用动画名称*/
  0% {
         filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
      }

  50% {
        filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));
  }
  100% {
         filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
      }
}
@keyframes left2 {    /*引用动画名称*/
  0% {
         filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
         transform: scale(0.8);
         transform: rotate(0);
      }

  50% {
        filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.2));
        transform: scale(1.02);
        transform: rotate(10deg);
  }
  100% {
         filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
         transform: scale(0.9);
         transform: rotate(0);
      }
}
@keyframes jiantou {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      
      right: 0;
      transform: scale(1);
  } 
  50%{                     
      
      right: 5px;
      transform: scale(1.01);
  }
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  100%{
    right: 0;
    transform: scale(1);
  }
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
